import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./Auth/ProtectedRoute";
/*this is comment */
import Layout from "./components/Layout/Layout";
import Login from "./components/Login/Login";

import ListOrganization from "./components/Organization/ListOrganization";
import CreateOrganization from "./components/Organization/CreateOrganization";
import ContactList from "./components/Contact/ContactsList";
import CreateContact from "./components/Contact/CreateContact";
import LeadsList from "./components/Leads/LeadsList";
import DealsList from "./components/Deals/DealsList";
import CreateLead from "./components/Leads/LeadsCreate";
import ExpensesList from "./components/Expenses/ExpensesList";
import RenewalsList from "./components/Renewal/RenewalList";
import UsersList from "./components/Users/UsersList";
import MyTasksList from "./components/Tasks/MyTasksList";
import Dashboard from "./components/Dashboard/Dashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected App Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="organizations" element={<ListOrganization />} />
          <Route path="organizations/create" element={<CreateOrganization />} />

          <Route path="contacts" element={<ContactList />} />
          <Route path="contacts/create" element={<CreateContact />} />

          <Route path="leads" element={<LeadsList />} />
          <Route path="leads/create" element={<CreateLead />} />
          <Route path="expenses" element={<ExpensesList />} />
          <Route path="deals" element={<DealsList />} />
          <Route path="renewal" element={<RenewalsList />} />
          <Route path="users" element={<UsersList />} />
          <Route path="tasks" element={<MyTasksList />} />
          <Route path="my-tasks" element={<MyTasksList />} />
          
        </Route>

        {/* Default Redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;